








































































































































































































































import { Component, Prop, Inject, Vue } from "vue-property-decorator";
import { getBirthday } from "@/services/dateTime/date-time-fofmat";
import { IGuest } from "@/@types/admin/guest/user";
import { IWikiObject as IWiki } from "@/@types/wiki/wiki-object";

import ButtonBoxArrowLeft from "@/components/buttons/button-box-arrow-left.vue";
import { Hooper, Slide } from "hooper";

import "hooper/dist/hooper.css";

@Component({ components: { ButtonBoxArrowLeft, Hooper, Slide } })
export default class HistoryWikiGraph extends Vue {
  @Inject({ from: "bgFolder", default: null }) readonly bgFolder!: string;
  @Inject({ from: "posterFolder", default: null }) readonly folder!: string;
  @Inject({ from: "galleryFolder", default: null }) readonly gFolder!: string;
  @Inject({ from: "iconFolder", default: null }) readonly iconFolder!: string;

  @Prop({ type: Object, default: null }) wiki!: IWiki;
  @Prop({ type: Array, default: () => [] }) users!: Array<IGuest>;

  active = 0;

  get history(): Array<Partial<IWiki>> {
    return this.wiki && this.wiki.update_history
      ? this.wiki.update_history.reverse()
      : [];
  }

  getManager(id: string): IGuest | null {
    const user = this.users.find((el: IGuest) => el._id == id);
    return user ? user : null;
  }

  getDate(date: Date): string {
    return getBirthday(date);
  }

  destroyed(): void {
    this.active = 0;
  }
}
